import { combineReducers } from 'redux'
import * as types from './types'
import * as authTypes from 'src/state/ducks/auth/types'

export const parseJson = (value) => {
  if (value)
    try {
      return JSON.parse(value)
    } catch (error) {}
  return null
}

const listReducer = (
  state = parseJson(localStorage.getItem(types.LIST)),
  action
) => {
  switch (action.type) {
    case types.LIST:
      localStorage.setItem(types.LIST, JSON.stringify(action.payload))
      return action.payload

    case authTypes.LOGOUT:
      localStorage.removeItem(types.LIST)
      return null

    default:
      return state
  }
}

const selectedReducer = (
  state = parseJson(localStorage.getItem(types.SELECT)),
  action
) => {
  switch (action.type) {
    case types.SELECT:
      if (action.payload)
        localStorage.setItem(types.SELECT, JSON.stringify(action.payload))
      else localStorage.removeItem(types.SELECT)

      return action.payload || null

    case authTypes.LOGOUT:
      localStorage.removeItem(types.SELECT)
      return null

    default:
      return state || null
  }
}

const listErrorReducer = (state = null, action) => {
  switch (action.type) {
    case types.LIST_ERROR:
      return action.payload || 'error'

    case types.LIST:
    case authTypes.LOGOUT:
      return null

    default:
      return state
  }
}

const reducer = combineReducers({
  list: listReducer,
  selected: selectedReducer,
  listError: listErrorReducer,
})

export default reducer
